module.exports = "<span (click)='playSound()' style=\"cursor: pointer\">\r\n  <i class=\"fa\" [ngClass]=\"{'fa-volume-up': !playing, 'fa-stop': playing}\"></i>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/components/simple-player/simple-player.component.html
// module id = ../../../../../src/app/shared/components/simple-player/simple-player.component.html
// module chunks = main